import { useId, type ReactNode } from 'react'
import '@/styles/record.css'

/**
 * Панель с заголовком (`.panel` / `.panel-h` / `.panel-b`) — правая колонка карточки.
 *
 * Заголовок связан с панелью `aria-labelledby`: «Позиции», «Участники», «Сведения» — это
 * разделы страницы, и диктор должен называть их так же, как их видит глаз.
 */
export interface PanelProps {
  title: ReactNode
  /** Число рядом с заголовком (`.count`). */
  count?: number | null
  /** Действия в шапке справа — ghost-кнопки. */
  actions?: ReactNode
  /** Без внутреннего отступа: таблица или список до краёв панели. */
  flush?: boolean
  children: ReactNode
}

export function Panel({ title, count, actions, flush, children }: PanelProps) {
  const id = useId()
  return (
    <section className="panel" aria-labelledby={id}>
      <div className="panel-h">
        <span className="h2" id={id}>
          {title}
        </span>
        {count !== undefined && count !== null && <span className="count">{count}</span>}
        <span className="spacer" />
        {actions}
      </div>
      {flush ? children : <div className="panel-b">{children}</div>}
    </section>
  )
}
